import React, { Component, Fragment } from "react";
import _ from "lodash";
import { ParallaxProvider } from "react-skrollr";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { loadReCaptcha, ReCaptcha } from "react-recaptcha-google";
import { Link, animateScroll as scroll } from "react-scroll";

import { withRedux, multiLanguage } from "../../hoc";
import { switchLanguage } from "../../actions/language";
import { switchLocation } from "../../actions/location";
import { initAppPreviewTrip } from "../../actions/preview-trip";
import { assetsPath } from "../../utils";

import { sendEmailOnlyService } from "../../services/email";

import { PrivacyPolicy } from '../../components'

const isDev = process.env.NODE_ENV === "development";

const PAGE_KEY = "preview-trip";

const emailSubject = "LP web – Complimentary preview trip offer";
const emailTo = isDev
  ? ["mondit.thum@gmail.com"]
  : [
      "Sherry.Jia@banyantree.com",
      "sinniont@lagunaproperty.com",
      "stefanoc@lagunaphuket.com"
    ];
const emailCC = isDev ? [] : ["info@lagunaproperty.com"];

const Error = ({ name, ...rest }) => {
  return (
    <Field
      name={name}
      subscription={{ touched: true, error: true }}
      render={({ meta: { touched, error } }) => {
        return touched && error ? (
          <div className="form-error">
            <span className="field-error">{error}</span>
          </div>
        ) : null;
      }}
    />
  );
};

const assetPath = path => `${assetsPath(PAGE_KEY)}/${path}`;

// const toNumberFormat = (number, decimals, decPoint, thousandsSep) => {
//   number = (number + '')
//     .replace(/[^0-9+\-Ee.]/g, '');
//   var n = !isFinite(+number) ? 0 : +number,
//     prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//     sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
//     dec = (typeof decPoint === 'undefined') ? '.' : decPoint,
//     s = '',
//     toFixedFix = function(n, prec) {
//       var k = Math.pow(10, prec);
//       return '' + (Math.round(n * k) / k)
//         .toFixed(prec);
//     };
//   // Fix for IE parseFloat(0.55).toFixed(0) = 0;
//   s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
//     .split('.');
//   if (s[0].length > 3) {
//     s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
//   }
//   if ((s[1] || '')
//     .length < prec) {
//     s[1] = s[1] || '';
//     s[1] += new Array(prec - s[1].length + 1)
//       .join('0');
//   }
//   return s.join(dec);
// }

const pickCurrencies = ["THB", "AUD", "CNY", "EUR", "HKD", "SGD", "GBP", "USD"];

const getCurrencies = _.memoize(countries => {
  return _.uniqBy(
    _.reduce(countries, (acc, country) => [...acc, ...country.currencies], []),
    "code"
  );
});

const mapStateToProps = state => {
  const countries = _.get(state, `${PAGE_KEY}.data.countries`, []);
  const uniqCurrencies = getCurrencies(countries);
  const currencies = _.filter(uniqCurrencies, currency =>
    _.includes(pickCurrencies, currency.code)
  );

  console.log('currencies', currencies)

  return {
    isMobile: state.device.isMobile,
    languages: state.language.languages,
    dictionary: _.get(state, `${PAGE_KEY}.data.dictionary`, {}),
    option: _.get(state, `${PAGE_KEY}.data.option`, {}),
    projects: _.get(state, `${PAGE_KEY}.data.project`, []),
    countryNameOptions: _.map(countries, country => ({
      label: country.name || "",
      value: country.name || ""
    })),
    currencyOptions: _.sortBy(
      _.map(currencies, currency => ({
        label: currency.code === 'USD' ? 'United States dollar' : currency.name,
        // label: currency.symbol
        //   ? `${currency.name} - ${currency.symbol}`
        //   : currency.name,
        value: currency.code || ""
      })),
      "label"
    ),
    nationalityOptions: _.map(
      _.get(state, `${PAGE_KEY}.data.option.nationalityOptions`, []),
      nationality => ({
        label: _.get(nationality, "nationality", ""),
        value: _.get(nationality, "nationality", "")
      })
    ),
    exchangeCurrencyRates: _.get(
      state,
      `${PAGE_KEY}.data.exchangeCurrencyRates.rates`,
      []
    )
  };
};

const actionToProps = {
  switchLanguage,
  switchLocation,
  initAppPreviewTrip
};

class PreviewTrip extends Component {
  constructor(props) {
    super(props);
    this.headerRef = React.createRef();
    this.captchaDemo = React.createRef();
    this.state = {
      showLanguageSelection: false,
      small: false,
      readyToLoadCaptcha: false,
      reCaptchaToken: "",
      submitted: false
    };
  }
  requiredFields = [
    "title",
    "firstName",
    "lastName",
    "nationality",
    "email",
    "mobilePhone",
    // 'landPhone',
    "city",
    "country",
    "currency",
    "budget",
    "projects",
    "question1",
    "question2"
  ];
  componentDidMount() {
    this.setLanguage(this.props.match.params.language);
    this.fetchData();
    loadReCaptcha();
    window.addEventListener("scroll", this.handleScrollPage);
    setTimeout(() => {
      this.setState({
        readyToLoadCaptcha: true
      });
    }, 1500);
  }
  componentDidUpdate(prevProps) {
    const currentLanguage = prevProps.match.params.language;
    const nextLanguage = this.props.match.params.language;
    if (currentLanguage !== nextLanguage) {
      this.setLanguage(nextLanguage);
    }
  }
  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScrollPage);
  };

  scrollToTop() {
    scroll.scrollToTop();
  }

  onLoadRecaptcha() {
    if (this.captchaDemo) {
      this.captchaDemo.reset();
      // this.captchaDemo.execute();
    }
  }

  getContent = key => {
    const { t, dictionary } = this.props;
    const content = dictionary[key];
    if (!content) {
      console.warn(`${key} could not be found in dictionary`, dictionary);
      return "";
    }
    if (_.isArray(content)) {
      return content;
    }
    return t(content);
  };
  updateDimensions = () => {
    const width = window.innerWidth;
    let offset = -90;
    if (width > 768) offset = -152;
    if (width > 1200) offset = -86;
    if (this.state.offset !== offset) this.setState({ offset });
  };
  setLanguage = language => {
    this.props.actions.switchLanguage(language);
  };
  fetchData = () => {
    this.props.actions.initAppPreviewTrip();
  };
  convertCurrencyRate = ({ value, from, to }) => {
    const { exchangeCurrencyRates } = this.props;
    const fromRate = _.get(exchangeCurrencyRates, from, 0);
    const toRate = _.get(exchangeCurrencyRates, to, 0);
    if (fromRate === 0 || toRate === 0) {
      // console.warn(`Cannot convert from ${from} to ${to} because cannot find one of them in exchangeCurrencyRates`)
      return 0;
    }
    return Math.round((value / fromRate) * toRate);
  };
  getBudgetOptions = values => {
    const { currency } = values;
    const { option, t } = this.props;
    const options = !_.isEmpty(currency)
      ? _.get(option, `budgetRateOptions.${currency}`, [])
      : _.get(option, `budgetRateOptions.THB`, []);
    return _.map(options, _option => {
      return {
        label: t(_option),
        value: t(_option)
      };
    });
    // const { t } = this.props
    // const { t, exchangeCurrencyRates } = this.props
    // console.log('getBudgetOptions', values, exchangeCurrencyRates)
    // return [
    //   {
    //     label: t({
    //       en: "Less than 10 million Baht",
    //       ru: "Менее 10 млн бат",
    //       cn: "Less than 10 million Baht"
    //     }),
    //     value: "Less than 10 million Baht"
    //   },
    //   {
    //     label: t({
    //       en: "Between 10 to 20 million Baht",
    //       ru: "От 10 до 20 млн бат",
    //       cn: "Between 10 to 20 million Baht"
    //     }),
    //     value: "Between 10 to 20 million Baht"
    //   },
    //   {
    //     label: t({
    //       en: "Between 20 to 40 million Baht",
    //       ru: "От 20 до 40 млн бат",
    //       cn: "Between 20 to 40 million Baht"
    //     }),
    //     value: "Between 20 to 40 million Baht"
    //   },
    //   {
    //     label: t({
    //       en: "More than 40 million Baht",
    //       ru: "Более 40 млн бат",
    //       cn: "More than 40 million Baht"
    //     }),
    //     value: "More than 40 million Baht"
    //   }
    // ]
    // return [
    //   {
    //     label: `Less than ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} ${currency}`,
    //     value: `Less than ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} ${currency}`,
    //   },
    //   {
    //     label: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} ${currency}`,
    //     value: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} ${currency}`,
    //   },
    //   {
    //     label: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
    //     value: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
    //   },
    //   {
    //     label: `More than ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
    //     value: `More than ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
    //   },
    // ]
  };
  getLanguageIcon = () => {
    const { languages, currentLanguage } = this.props;
    const targetLanguage = _.find(languages, language => {
      return language.key === currentLanguage;
    });
    return (targetLanguage && targetLanguage.icon) || "";
  };
  handleScrollPage = () => {
    const { small } = this.state
    const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.lastScrollY = pageYOffset;
    if (this.lastScrollY > 30 && small === false) {
      this.setState({
        small: true
      });
    } else if (this.lastScrollY <= 30 && small === true) {
      this.setState({
        small: false
      });
    }
  };
  handleSwitchLanguage = nextLanguage => {
    const { currentLanguage, location } = this.props;
    const { pathname } = location;
    const nextUrl = _.replace(
      pathname,
      `/${currentLanguage}/`,
      `/${nextLanguage}/`
    );
    this.props.history.push(nextUrl);
  };
  handleVerifyReCaptchaCallback = reCaptchaToken => {
    console.log("handleVerifyReCaptchaCallback", reCaptchaToken);
    this.setState({
      reCaptchaToken
    });
  };
  handleValidate = values => {
    // console.log('validate', values);
    const errors = {};

    _.forEach(this.requiredFields, fieldName => {
      if (fieldName === "email") {
        const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;
        if (emailRegex.test(values.email) === false) {
          errors[fieldName] = "email format is wrong.";
        }
      }
      if (_.isEmpty(values[fieldName])) {
        errors[fieldName] = this.getContent('fieldRequired')
      }
    });
    return errors;
  };
  handleSubmit = async (values, form) => {
    const { reCaptchaToken } = this.state;
    console.log("handleSubmit", reCaptchaToken, values, form);

    if (_.isEmpty(reCaptchaToken)) {
      return { [FORM_ERROR]: "Please check Recaptcha." };
    }

    // const firstError = _.find(this.requiredFields, fieldKey =>
    //   _.isEmpty(values[fieldKey])
    // );

    // if (!_.isEmpty(firstError)) {
    //   return { [FORM_ERROR]: `${_.capitalize(firstError)} is required.` };
    // }
    try {
      await sendEmailOnlyService({
        subject: emailSubject,
        to: emailTo,
        cc: emailCC,
        reCaptchaToken,
        data: {
          Title: _.get(values, "title", ""),
          "First Name": _.get(values, "firstName", ""),
          "Last Name": _.get(values, "lastName", ""),
          Nationality: _.get(values, "nationality", ""),
          Email: _.get(values, "email", ""),
          "Mobile Phone": _.get(values, "mobilePhone", ""),
          "Land Phone": _.get(values, "landPhone", ""),
          City: _.get(values, "city", ""),
          Country: _.get(values, "country", ""),
          Currency: _.get(values, "currency", ""),
          Budget: _.get(values, "budget", ""),
          Project: _.join(_.get(values, "projects", []), ", "),
          "Do you already have investment(s) in Thailand?": _.capitalize(
            _.get(values, "question1", "")
          ),
          "Do you already have investment(s) with Laguna Properties or its subsidiaries?": _.capitalize(
            _.get(values, "question2", "")
          )
        }
      });
      this.setState({
        submitted: true
      });
      window.scrollTo(0, 0);
    } catch (error) {
      console.error(error);
    }
  };
  handleGoBackToFormPage = () => {
    this.setState({
      submitted: false
    });
  };
  toggleShowLanguageSelection = () => {
    this.setState({
      showLanguageSelection: !this.state.showLanguageSelection
    });
  };
  renderLanguageOption = ({ name, key, icon, ...rest }) => {
    return (
      <li key={key}>
        <a onClick={this.handleSwitchLanguage.bind(this, key)}>
          <img alt="" src={icon} />
          {name}
        </a>
      </li>
    );
  };
  renderCheckboxField = ({ name, label, options, required }) => {
    return (
      <div className="form-field">
        <h4 className="field-label" style={{ display: label ? 'block' : 'none' }}>
          {label} {required && <span>*</span>}
        </h4>
        <div>
          {_.map(options, ({ label, value }) => {
            return (
              <label style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <Field
                  name={name}
                  component="input"
                  type="checkbox"
                  value={value}
                />{" "}
                <span>
                  <span>
                    <svg className="checkmark" viewBox="0 0 24 24">
                      <path
                        className="checkmark-path"
                        fill="none"
                        stroke="white"
                        d="M1.73,12.91 8.1,19.28 22.79,4.59"
                      />
                    </svg>
                  </span>
                </span>
                {label}
              </label>
            );
          })}
        </div>
      </div>
    );
  };
  renderRadioField = ({ name, label, options, required }) => {
    return (
      <div className="form-container">
        <div className="form-field">
          <h4 className="field-label">
            {label} {required && <span className="icon-required">*</span>}
          </h4>
          <div>
            {_.map(options, ({ label, value }) => {
              return (
                <label>
                  <Field
                    name={name}
                    component="input"
                    type="radio"
                    value={value}
                  />
                  <span>
                    <span />
                  </span>
                  {label}
                </label>
              );
            })}
          </div>
        </div>
        <Error name={name} />
      </div>
    );
  };
  renderTextField = ({ name, type = "text", placeholder, label, required }) => {
    return (
      <div className="form-container">
        <Error name={name} />
        <div className="form-field">
          <h4 className="field-label" style={{ opacity: !label ? 0 : 1 }}>
            {label} {required && <span className="icon-required">*</span>}
          </h4>
          <Field
            name={name}
            component="input"
            type={type}
            placeholder={placeholder}
          />
        </div>
      </div>
    );
  };
  renderSelectField = ({ name, label, options, placeholder, required }) => {
    return (
      <div className="form-container">
        <Error name={name} />
        <div className="form-field">
          <h4 className="field-label">
            {label} {required && <span className="icon-required">*</span>}
          </h4>
          <Field name={name} component="select">
            <option value="">{placeholder}</option>
            {_.map(options, ({ label: optionLabel, value: optionValue }) => (
              <option value={optionValue}>{optionLabel}</option>
            ))}
          </Field>
        </div>
      </div>
    );
  };
  renderForm = () => {
    const { readyToLoadCaptcha } = this.state;
    const {
      projects,
      option,
      t,
      nationalityOptions,
      countryNameOptions,
      currencyOptions
    } = this.props;
    return (
      <Fragment>
        <section id="welcome">
          <h1>{this.getContent("welcomeHeading")}</h1>
          <div className="sub-heading">
            <h4>{this.getContent("welcomeSubHeading")}</h4>
          </div>
        </section>
        <form>
          <Form
            onSubmit={this.handleSubmit}
            initialValues={{}}
            validate={this.handleValidate}
            render={({
              submitError,
              handleSubmit,
              form,
              submitting,
              pristine,
              values
            }) => (
              <Fragment>
                <section id="basic-information">
                  <h2>{this.getContent("basicInformation")}</h2>
                  <hr />
                  <div className="row">
                    <div className="col-md-4">
                      {this.renderSelectField({
                        name: "title",
                        placeholder: "Choose...",
                        label: this.getContent("title"),
                        options: _.map(
                          _.get(option, "titleOptions", []),
                          ({ label, value }) => ({
                            label: t(label),
                            value: value
                          })
                        ),
                        required: true
                      })}
                    </div>
                    <div className="col-md-4">
                      {this.renderTextField({
                        name: "firstName",
                        placeholder: this.getContent("firstName"),
                        label: this.getContent("name"),
                        required: true
                      })}
                    </div>
                    <div className="col-md-4">
                      {this.renderTextField({
                        name: "lastName",
                        placeholder: this.getContent("lastName"),
                        required: true
                      })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      {this.renderSelectField({
                        name: "nationality",
                        placeholder: "Choose your nationality...",
                        label: this.getContent("nationality"),
                        options: nationalityOptions,
                        required: true
                      })}
                    </div>
                    <div className="col-md-6">
                      {this.renderTextField({
                        name: "email",
                        label: this.getContent("email"),
                        placeholder: "Example: Name@company.com",
                        required: true
                      })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      {this.renderTextField({
                        name: "mobilePhone",
                        label: this.getContent("phone"),
                        placeholder: this.getContent("mobilePhone"),
                        type: "tel",
                        required: true
                      })}
                    </div>
                    <div className="col-md-6">
                      {this.renderTextField({
                        name: "landPhone",
                        placeholder: this.getContent("landPhone"),
                        type: "tel",
                        required: true
                      })}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      {this.renderTextField({
                        name: "city",
                        label: this.getContent("location"),
                        placeholder: this.getContent("city"),
                        required: true
                      })}
                    </div>
                    <div className="col-md-6">
                      {this.renderSelectField({
                        name: "country",
                        label: this.getContent("country"),
                        placeholder: this.getContent("country"),
                        options: countryNameOptions,
                        required: true
                      })}
                    </div>
                  </div>
                </section>
                <section id="investment-options">
                  <h2>{this.getContent("investmentOptions")}</h2>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      {this.renderSelectField({
                        name: "currency",
                        placeholder: "Choose your currency...",
                        label: this.getContent("selectCurrency"),
                        options: currencyOptions,
                        required: true
                      })}
                    </div>
                    <div className="col-md-6">
                      {this.renderSelectField({
                        name: "budget",
                        placeholder: "Choose your investment budget...",
                        label: this.getContent("selectBudget"),
                        options: this.getBudgetOptions(values),
                        required: true
                      })}
                    </div>
                  </div>
                </section>
                <section id="project-selection">
                  <div className="row">
                    {projects.map(
                      ({ key, theme = "", value, logo, thumbnail, list }) => (
                        <div className="column col-lg-6 col-md-12" key={key}>
                          <div className={`project-card ${key}`}>
                            <div className="logo image-wrapper">
                              {/* <img src={assetPath("logo4.png")} /> */}
                              <img src={assetPath(logo)} />
                            </div>
                            <div className="thumbnail image-wrapper">
                              <img src={assetPath(thumbnail)} />
                            </div>
                            <div className="content">
                              <ul>
                                {list.map(item => (
                                  <li key={t(item)}>
                                    <h2>{t(item)}</h2>
                                  </li>
                                ))}
                              </ul>
                            </div>
                            <div className={`action ${theme}`}>
                              {this.renderCheckboxField({
                                name: "projects",
                                options: [
                                  {
                                    label: this.getContent("interested"),
                                    value
                                  }
                                ]
                              })}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </section>
                <section id="almost-there">
                  <h2>{this.getContent("almostThere")}</h2>
                  <hr />
                  <div className="col-sm-12">
                    {this.renderRadioField({
                      name: "question1",
                      label: this.getContent("question1"),
                      options: [
                        {
                          label: this.getContent("yes"),
                          value: "yes"
                        },
                        {
                          label: this.getContent("no"),
                          value: "no"
                        }
                      ],
                      required: true
                    })}
                  </div>
                  <div className="col-sm-12">
                    {this.renderRadioField({
                      name: "question2",
                      label: this.getContent("question2"),
                      options: [
                        {
                          label: this.getContent("yes"),
                          value: "yes"
                        },
                        {
                          label: this.getContent("no"),
                          value: "no"
                        }
                      ],
                      required: true
                    })}
                  </div>
                </section>
                {readyToLoadCaptcha && (
                  <ReCaptcha
                    ref={el => (this.captchaDemo = el)}
                    size="normal"
                    data-theme="dark"
                    render="explicit"
                    sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA}
                    onloadCallback={this.onLoadRecaptcha}
                    verifyCallback={this.handleVerifyReCaptchaCallback}
                  />
                )}
                <br />
                {submitError && <div className="error">{submitError}</div>}
                <br />
                <button
                  className="button"
                  type="submit"
                  disabled={submitting}
                  onClick={handleSubmit}
                >
                  {this.getContent("submit")}
                </button>
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </Fragment>
            )}
          />
        </form>
      </Fragment>
    );
  };
  renderThankyou = () => {
    const { currentLanguage } = this.props;
    return (
      <section id="thankyou">
        <h2 className="content">{this.getContent("thankyou")}</h2>
        <br />
        <a href={`https://lagunaproperty.com/${currentLanguage}`}>
          <button className="button">{this.getContent("viewFullSite")}</button>
        </a>
      </section>
    );
  };
  render() {
    const { small, submitted, showLanguageSelection } = this.state;
    const { languages, currentLanguage } = this.props;
    return (
      <Fragment>
        <Helmet>
          <title>Laguna Preview Trip</title>
        </Helmet>
        <header
          className={`header ${PAGE_KEY} ${small ? "small" : ""}`}
          ref={this.headerRef}
        >
          {submitted && (
            <div className={`top-action ${PAGE_KEY}`}>
              <div onClick={this.handleGoBackToFormPage} className="nav">
                <div className="arrow-left" />
                <h4>{this.getContent('backToPrevious')}</h4>
              </div>
            </div>
          )}
          <img src={assetPath("logo-banyantree-group.png")} alt="" />
          <div
            className={`language ${showLanguageSelection ? "open" : ""}`}
            onClick={this.toggleShowLanguageSelection}
          >
            <img className="current-lang" alt="" src={this.getLanguageIcon()} />
            <img
              src="data:image/svg+xml;base64,PHN2ZyBmaWxsPSdibGFjaycgaGVpZ2h0PScyNCcgdmlld0JveD0nMCAwIDI0IDI0JyB3aWR0aD0nMjQnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHBhdGggZD0nTTcgMTBsNSA1IDUtNXonLz48cGF0aCBkPSdNMCAwaDI0djI0SDB6JyBmaWxsPSdub25lJy8+PC9zdmc+"
              alt=""
            />
            <ul className={`list`}>
              {languages.map(this.renderLanguageOption)}
            </ul>
          </div>
        </header>
        <div className={`main-content ${PAGE_KEY}`}>
          <div className="container">
            <div className="widget">
              {submitted ? this.renderThankyou() : this.renderForm()}
            </div>
          </div>
        </div>
        {!submitted && (
          <div className={`bottom-action ${PAGE_KEY}`}>
            <div onClick={this.scrollToTop} className="navigation">
              <div class="arrow-up" />
              <h4>Back To Top</h4>
            </div>
          </div>
        )}
        <footer className={`footer ${PAGE_KEY}`}>
          <h4>© 2019 BANYAN TREE GROUP</h4>
          <ul>
            <li>
              <a
                target="_blank"
                href={`https://lagunaproperty.com/${currentLanguage}/privacy-policy`}
              >
                {this.getContent("privacy")}
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href={`https://lagunaproperty.com/${currentLanguage}/terms`}
              >
                {this.getContent("term")}
              </a>
            </li>
          </ul>
        </footer>
        <PrivacyPolicy
          text={this.getContent('cookiePrivacy')}
          linkText={this.getContent('cookiePrivacyLink')}
          buttonText={this.getContent('accept')}
          href={`http://lagunaproperty.com/${currentLanguage}/privacy-policy`}
        />
      </Fragment>
    );
  }
}

export default multiLanguage()(
  withRedux(mapStateToProps, actionToProps)(withRouter(PreviewTrip))
);



// WEBPACK FOOTER //
// ./src/pages/PreviewTrip/index.js